import { ajax } from "../services/ajax";
import { api } from "../constants";

export default channel => {
  const formData = new FormData();
  formData.append('data', JSON.stringify(channel.data));
  if (channel.cover) formData.append('cover', channel.cover);
  if (channel.englishCover) formData.append('englishCover', channel.englishCover);
  if (channel.tag) formData.append('tag', JSON.stringify(channel.tag));
  if (channel.excludeTag) formData.append('excludeTag', JSON.stringify(channel.excludeTag));
  if (channel.tracks) {
    const items = channel.tracks.items.map(track => ({
      id: track.id,
      name: track.name
    }));
    formData.append('track', JSON.stringify({ items }));
  }
  return ajax.post(api.endpoints.channels.add[channel.type], formData)
}
